import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-lg-4" }
const _hoisted_3 = { class: "col-lg-8" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col-lg-4" }
const _hoisted_6 = { class: "col-lg-4" }
const _hoisted_7 = { class: "col-lg-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NewAndSolvedTicketsChart = _resolveComponent("NewAndSolvedTicketsChart")!
  const _component_TicketsStatusChart = _resolveComponent("TicketsStatusChart")!
  const _component_TasksOverviewChart = _resolveComponent("TasksOverviewChart")!
  const _component_CustomerSatisfactionChart = _resolveComponent("CustomerSatisfactionChart")!
  const _component_ResponseTimeChart = _resolveComponent("ResponseTimeChart")!
  const _component_PerformanceOfAgents = _resolveComponent("PerformanceOfAgents")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_NewAndSolvedTicketsChart)
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_TicketsStatusChart)
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_TasksOverviewChart)
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_CustomerSatisfactionChart)
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_ResponseTimeChart)
      ])
    ]),
    _createVNode(_component_PerformanceOfAgents)
  ]))
}